import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React, { useState } from 'react'
import { Camera, Scale, TriangleAlert, ListOrdered, RefreshCw } from 'lucide-react'
import IntegrationsPanel from './IntegrationsPanel'
import s from './IntegrationsPanel.module.scss'

export default function IntegrationHub() {
  useInterfaceLanguage();
  const [resource, setResource] = useState('violations')
  return <div><nav className={s.toolbar} aria-label={tr("Разделы интеграций")}>{[
    ['violations', tr("Нарушения"), TriangleAlert], ['scans', tr("Сканирования"), Camera],
    ['weighings', tr("Весы"), Scale], ['weighing-cards', tr("Взвешивания 1С"), Scale], ['queues', tr("Полосы"), ListOrdered],
    ['sync-status', tr("Синхронизация"), RefreshCw],
  ].map(([key, label, Icon]) => <button key={key} className={s.button} aria-pressed={resource === key} onClick={() => setResource(key)} style={resource === key ? { background: "var(--theme-primary-soft, #eeedff)", color: "var(--theme-primary-text, #0d00f3)", borderColor: "var(--theme-primary-border, #c1bdff)" } : undefined}><Icon size={16} />{tr(label)}</button>)}</nav><IntegrationsPanel key={resource} resource={resource} /></div>
}
